<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <div v-show="Isblur" class="splash"></div>

    <sidebar></sidebar>
    <!-- Jobs -->
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start">
              <h2 style="font-size: 1.2vw !important; text-align: right">ارزیابی ذی نفعان</h2>
            </div>
            <hr class="mb-3">
            <div class="d-flex flex-nowrap">
              <div class="card col-6 p-3 d-flex flex-column align-items-center justify-content-center ">
                <h3> چارچوب فریمن   </h3>
                <router-link to="/beneficiary/order_by/power" class="btn btn-submit-1 btn-primary"
                             style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی
                </router-link>
              </div>



              <div class="card col-6 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
                <h3> چارچوب میچل</h3>
                <router-link to="/beneficiary/order_by/Mitchell" class="btn btn-submit-1 btn-primary"
                             style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی
                </router-link>
              </div>

          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
export default {
  name: "beneficiary_id_order_by",
  components: {Sidebar, Splash}
}
</script>

<style scoped>
.row{
  padding: .5vw;
}
h3{
  font-size: 1.5vw !important;
}
</style>